import { useRef } from "react"
import Courses from "../courses"
import { useInView } from "framer-motion"

const Colleges = () => {
    const ref = useRef(null)
    const useIsInView = useInView(ref, { once: true })
    return (
        <div ref={ref} className="flex flex-col ga-8 items-center">
            <h1 className="text-center text-black text-3xl font-semibold">Colleges in Campus</h1>
            <div className="max-w-6xl">
                <Courses useIsInView={useIsInView} />
            </div>

        </div>
    )
}

export default Colleges